<template>
  <div class="container">
    <b-row>

      <b-col cols="12" class="my-4">
        <b-row>
          <b-col lg="4" class="my-3">
            <img class="col-lg-12" :src="category.image" :alt="category.name">
          </b-col>
          <b-col lg="8" class="my-3">
            <h3>{{ category.name }}</h3>
            <div v-if="category.description != null" v-html="category.description" class="card-text"></div>
          </b-col>

        </b-row>
      </b-col>


      <b-container>
        <b-col class="text-center">
          <h3>محصولات دسته بندی</h3>
        </b-col>
        <hr>

        <b-row id="single-category-archive-300">

          <div  class="col-lg-3 mt-3" v-for="product in products" :key="product.id">
            <m-c301 class="product-card" :product="product"/>
          </div>


        </b-row>

        <b-row class="text-center mt-3 ">
          <b-col lg="12">
            <m-pagination-400 :meta="meta" :onChangePage="changePage"/>
          </b-col>
        </b-row>


      </b-container>


    </b-row>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {
  convertToJalaliWithTime, formatNumber,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {addUnAuthItem, basketAddItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import router from "@/router";

export default {
  name: "SingleCategory300",
  props: {
    is_digital: {
      default: ''
    },
    title: {
      default: ''
    },
    firstCategory: {
      default: 'آخرین محصولات',
    },
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
  },
  computed: {
    ...mapGetters({
      category: 'Category/getCategory',
      products: "Product/getProducts",
      meta: "Product/getPaginationMeta",
      IsAuthenticated: "User/isAuthenticated",
    })
  },
  methods: {
    getCategoryDate(date) {
      return convertToJalaliWithTime(date, "/");
    },
    changePage(page) {
      this.$store.dispatch('Product/setProducts', page);
      router.push({name: "SingleCategory", query: {...router.currentRoute.query, page: page}})
    },
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
  },
  async mounted() {

    await this.$store.dispatch('Category/getCategory', this.$route.params.slug)

  },
  watch: {
    category: {
      handler(newCategory, oldCategory) {

        this.$store.commit('Product/setFilters', {key: "is_digital", value: ''});
        this.$store.commit('Product/setFilters', {key: "sort", value: ''});
        this.$store.commit('Product/setFilters', {key: "search", value: ''});
        this.$store.commit('Product/setFilters', {key: "brand", value: []});
        this.$store.commit('Product/setFilters', {key: "category", value: [newCategory.id]});
        this.$store.dispatch('Product/setProducts');

      },
      deep: true
    },
  }
};
</script>

<style >

#single-category-archive-300 .product-card .price-now {
  color: black !important;
}
</style>

<style scoped>

</style>